<template>
  <!-- Footer start -->
  <section class="bg-[#1A1A1B] h-auto w-full flex flex-col">
    <div
      class="w-full text-center px-6 py-6 lg:py-14 2xl:px-40 text-[#BBBBBB] text-sm md:text-base tracking-widest font-montserrat"
    >
      <p >
        If you ever feel that gambling is becoming a problem, we urge you to seek help and
        support. Most people gamble for fun and enjoyment. However, some people think of
        gambling as a way to make money, spend more than they can afford, or use gambling
        to distract themselves from everyday problems. To find further advice, help and
        support visit:
        <a
          href="https://www.begambleaware.org/"
          target="_blank"
          class="text-white underline"
        >
          https://www.begambleaware.org/
        </a>
      </p>

      <p  class="mt-4">
        We do not take responsibility for misunderstood promotions, losses from gambling
        in casinos or betting on sites which are linked to or promoted on this website.
        Make sure it is legal for you to use each site inside your jurisdiction, and
        ALWAYS gamble responsibly!
      </p>
    </div>

    <!-- All Rights Reserved -->
    <div
      
      class="w-full text-center py-4 text-white text-xs md:text-sm tracking-widest bg-[#2588CF] font-montserrat"
    >
      @2025 BALLYBOY - ALL RIGHTS RESERVED
    </div>
  </section>
  <!-- Footer end -->
</template>
